<script>
import Vue from 'vue';
import LoadingModal from './LoadingModal.vue';
import { getPageConfigProperty } from '../../util/PageConfig';
import {extendSession} from '../../util/SessionExtension';

export default {
    name: 'PgbaBaseComponent',
    computed: {
        supportAccessReadOnly: {
            cache: false,
            get() {
                return (getPageConfigProperty('pageMetadata.supportUserReadOnly') === 'true');
            }
        }
    },
    methods: {
        showLoading() {
            if (!this.loadingModal) {
                const ModalClass = Vue.extend(LoadingModal);
                this.loadingModal = new ModalClass();
                this.loadingModal.$mount(); // pass nothing
                try {
                    this.$el.appendChild(this.loadingModal.$el); // insert into DOM
                } catch (error) {
                    // not all nodes allow this (ie. unit testing)
                    // the component is still usable, just not visible in the document,
                    // which is ok for unit testing
                }
            }
            this.loadingModal.show();
        },

        hideLoading() {
            if (this.loadingModal) {
                this.loadingModal.hide();
            }
        },

        goToHomePage() {
            let homePageUrl = getPageConfigProperty('themeConfig.homePageUrl');
            console.log(`homePageUrl: ${homePageUrl}`);
            if (homePageUrl) {
                window.location.replace(homePageUrl);
            }
        },

        extendSession() {
            extendSession();
        }
    }
};
</script>

<style>
.modal{
    z-index: 925 !important;
}

.modal-backdrop {
    z-index: 920 !important;
}
</style>
